<p [title]="getSupportingText()" [ngClass]="isValid() ? 'control-help-text' : 'control-invalid-text'">{{getSupportingText()}}</p>
